import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { OtpVerificationComponent } from 'app/pages/content-layout-page/register/otpverification/otpverification.component';
import { environment } from 'environments/environment';
import { AlertService } from 'services/alert.service';
import { AuthenticationService } from 'services/authentication.service';
import { NavigationService } from 'services/navigation.service';
import { UserService } from 'services/user.service';
import { UserSessionService } from 'services/usersession.service';

@Component({
  selector: 'app-myprofile',
  templateUrl: './myprofile.component.html',
  styleUrls: ['./myprofile.component.scss']
})
export class MyprofileComponent implements OnInit {

  form: FormGroup;
  titleList: any[];
  usersession: any;
  siteKey = environment.recaptcha.siteKey;
  recaptchaToken: string = "";
  IsRecaptchaRequired = false;
  mobileNumUpdate: boolean = false;
  res: any;
  isResellerLogin: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private userService: UserService,
    private authService: AuthenticationService,
    private navigationService: NavigationService,
    private alertService: AlertService, private router: Router,
    private userSessionService: UserSessionService,
    private dialog: MatDialog) {
    this.usersession = this.userSessionService.getUserSession()
    if (this.usersession.roleId == 4) {
      this.isResellerLogin = true;
    }
  }

  ngOnInit() {
    this.initializeValidators();
    this.getTitleType(true);
    this.getUserDetails(true);
    const mobileCtrl = this.form.get('mobileNumber');
    if (mobileCtrl) {
      mobileCtrl.valueChanges.subscribe((value) => {
        const normalize = (num: string) =>
          num ? num.replace(/\s+/g, '').replace(/^(\+27)/, '') : '';

        const current = normalize(value);
        const original = normalize(this.res.mobileNumber);

        if (current !== original) {
          this.mobileNumUpdate = true;
        }
        else {
          this.mobileNumUpdate = false;
        }
      });
    }
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      id: [0, null],
      title: ['', [Validators.required]],
      firstName: ['', [Validators.required, Validators.pattern('.*\\S.*[a-zA-z ]')]],
      lastName: ['', [Validators.required, Validators.pattern('.*\\S.*[a-zA-z ]')]],
      identificationNumber: ['', [Validators.required]],
      mobileNumber: ['', [Validators.required, Validators.pattern('[0-9]*')]],
      email: ['', [Validators.required, Validators.email]],
      salesRepCode: [''],
      referenceNumber: [''],
      whatsAppNumber: ['', [Validators.pattern('[0-9]*')]],
      resellerGroupCode: ['']
    });
  }
  getUserDetails(refresh) {

    const userId = this.userSessionService.userId();
    this.userService.getUser(userId, refresh).subscribe(user => {
      this.res = user
      this.form.patchValue(user);

    });
  }
  onUpdate() {
    debugger;
    if (!this.mobileNumUpdate) {
      this.updateProfileOnly();
      return;
    }
    if (!this.recaptchaToken) {
      this.IsRecaptchaRequired = true;
      return;
    }

    this.IsRecaptchaRequired = false;

    if (this.form.value.mobileNumber) {
      if (this.form.value.mobileNumber.length < 9) {
        this.alertService.warning('Please enter valid cellphone number');
        return;
      }
      else if (this.form.value.mobileNumber.length === 10) {
        if (this.form.value.mobileNumber[0] !== '0') {
          this.alertService.warning('Please enter valid cellphone number');
          return;
        }
      }
    }

    if (!this.form.valid) {
      this.validateFormControl();
      return;
    }
    const formValues = this.form.getRawValue();
    const payload = {
      CaptchaToken: this.recaptchaToken,
      recipient: formValues.mobileNumber,
      otpPageType: 2,
      notificationPreferenceType: 2
    };
    this.authService.verifyCaptchaAndGenerateOTP(payload)
      .subscribe(res => {
        if (!res.isSuccess) {
          this.alertService.error(res.errorMessage);
          return;
        }
        const dialogRef = this.dialog.open(OtpVerificationComponent, {
          autoFocus: false,
          disableClose: true,
          panelClass: ['mat-dialog', 'responsive-dialog'],
          width: '90vw',
          data: {
            registerOTPVerification: true,
            ValidateOtpId: res.value.id,
            registerDetails: formValues
          }
        });

        dialogRef.afterClosed().subscribe(verified => {
          if (verified) {
            this.updateProfileOnly();
          }
        });
      });
  }

  private updateProfileOnly() {
    if (!this.form.valid) {
      this.validateFormControl();
      return;
    }

    this.userService.updateUser(this.form.value).subscribe(result => {
      if (result && result.value > 0) {
        this.alertService.success('Profile updated successfully!');
        this.userService.updateuserBenefits(this.form.value).subscribe();
        if (!this.isResellerLogin) {
          this.router.navigate(['dashboard']);
        }
        else {
          this.router.navigate(['reseller-dashboard']);
        }
      }
      else if (result && result.failures && result.failures[0] === 'Email already exists') {
        this.alertService.warning('Email already exist');
      }
      else if (result && result.failures && result.failures[0] === 'Mobile Number already exists') {
        this.alertService.warning('Cellphone Number already exists');
      }
      else {
        this.alertService.warning('Something wrong your request not accepted');
      }
    });
  }



  // onUpdate() {
  //   if (this.recaptchaToken == null) {
  //     this.IsRecaptchaRequired = true;
  //     return;
  //   }
  //   else
  //     this.IsRecaptchaRequired = false;

  //   if (this.form.value.mobileNumber) {
  //     if (this.form.value.mobileNumber.length < 9) {
  //       this.alertService.warning('Please enter valid cellphone number');
  //       return;
  //     }
  //     else if (this.form.value.mobileNumber.length == 10) {
  //       var mobile = this.form.value.mobileNumber[0];
  //       if (mobile != 0) {
  //         this.alertService.warning('Please enter valid cellphone number');
  //         return;
  //       }
  //     }
  //   }
  //   if (this.form.valid) {
  //     let formValues = this.form.getRawValue();
  //     debugger
  //     var payloaddata: any = {}
  //     payloaddata.idNumber = formValues.identificationNumber;
  //     payloaddata.email = formValues.email;
  //     const payload = {
  //       CaptchaToken: this.recaptchaToken,
  //       recipient: formValues.mobileNumber,
  //       otpPageType: 2
  //     }
  //     this.authService.verifyCaptchaAndGenerateOTP(payload).subscribe((res) => {
  //       if (res.isSuccess == true) {

  //         const dialogRef = this.dialog.open(OtpVerificationComponent, {
  //           autoFocus: false,
  //           disableClose: true,
  //           panelClass: ['mat-dialog', 'responsive-dialog'],
  //           width: '50vw',
  //           data: {
  //             registerOTPVerification: true,
  //             ValidateOtpId: res.value.id,
  //             registerDetails: formValues,
  //           },
  //         }
  //         );

  //         dialogRef.afterClosed().subscribe((data) => {
  //           debugger;
  //           if (data) {
  //             if (this.form.valid) {
  //               this.userService.updateUser(this.form.value).subscribe(result => {
  //                 if (result) {
  //                   if (result.value > 0) {
  //                     this.alertService.success('Profile updated successfully!');
  //                     this.userService.updateuserBenefits(this.form.value).subscribe(res => {
  //                       if (res) {

  //                       }
  //                     })
  //                     // this.navigationService.goToLogin();
  //                   }
  //                   else if (result.failures[0] === "Email already exists") {
  //                     this.alertService.warning('Email already exist');
  //                   }
  //                   else if (result.failures[0] === "Mobile Number already exists") {
  //                     this.alertService.warning('Cellphone Number already exists');
  //                   }
  //                   else {
  //                     this.alertService.warning('Something wrong your request not accepted');
  //                   }
  //                 }
  //               });
  //             } else {
  //               this.validateFormControl();
  //             }
  //           }
  //         });
  //       }
  //       else if (res.isSuccess != true)
  //         this.alertService.error(res.errorMessage)
  //     });
  //   }
  // }

  onCancel() {
    if (this.isResellerLogin) {
      this.navigationService.goToResellerDashboard();
    }
    else {
      this.navigationService.goToDashboard();
    }
  }
  getTitleType(refresh) {
    try {
      this.userService.getTitleType(refresh).subscribe(result => {
        this.titleList = [];
        this.titleList = result;
        // console.log('this.weekDaysList', this.weekDaysList);
      });

    } catch (error) {

    }
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }

  titleChange(value) {

  }

  onCaptchaResolved(token) {
    this.recaptchaToken = token;
    console.log(this.recaptchaToken);

  }

}
